import { Component, OnInit, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-product-banners',
    templateUrl: './product-banners.component.html',
    styleUrls: ['./product-banners.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class ProductBannersComponent implements OnInit {

  @Input() promo: any;
  constructor() { }

  ngOnInit(): void {
  }

  public goBannerLink(url: string): void {
    window.open(url);
  }

}
